import { Org } from "@/types/org";
import { createSlice } from "@reduxjs/toolkit";

export interface orgState {
    curOrg: Org,
}

const initialState: orgState = {
    curOrg: {} as Org,
}

export const orgSlice = createSlice({
    name: 'orgReducer',
    initialState: initialState,
    reducers: {
        setCurOrg(state: orgState, {payload}) {
            state.curOrg = payload
        },
        resetOrgState: () => initialState
    }
})

export const { setCurOrg , resetOrgState } = orgSlice.actions
export default orgSlice.reducer